<template>
    <el-tabs stretch v-model="activeActiveCom" type="card" @tab-click="handleTabs" :stretch="stretch" :class="stretch ? 'mb15' : ''">
        <template v-if="isSHowIcon">
            <el-tab-pane v-for="item in tabs" :key="item.status" :name="item.name" :label="$t(item.label)"></el-tab-pane>
        </template>
        <template v-else>
            <el-tab-pane v-for="item in tabs" :key="item.id" :name="item.id" :title="$t(item.title)"> <i :class="item.icon" :title="item.title" slot="label"></i> </el-tab-pane>
        </template>
    </el-tabs>
</template>

<script>
export default {
    // props: ['activeCom', 'tabs', 'stretch', 'isSHowIcon'],
    props: {
        activeCom: {
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default: () => []
        },
        stretch: {
            type: Boolean,
            default: false
        },
        isSHowIcon: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        activeActiveCom: {
            get: function() {
                return this.activeCom;
            },
            set: function(val) {
                this.$emit('update:activeCom', val);
            }
        }
    },
    methods: {
        handleTabs({ name }) {
            let obj = {};
            (this.tabs || []).forEach(item => {
                if (item.name === name) {
                    obj = item;
                }
            });
            this.$emit('handleTabs', obj);
        }
    }
};
</script>

<style lang="scss" scoped>
.mb15 {
    ::v-deep .el-tabs__header {
        margin: 0 !important;
    }

    ::v-deep .el-tabs__content {
        height: 0% !important;
    }

    ::v-deep .el-tabs__nav {
        border-radius: 0;
        border: none;
        border-top: 1px solid #dfe4ed;
        border-bottom: 1px solid #dfe4ed;
    }
}
</style>
